var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-payment-status"},[_c('viewWrapper',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('p24',{attrs:{"endProcess":true,"state":_vm.status,"payment_url":_vm.paymentData.payment_url}}),_c('ADService')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }